/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Reply_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Notes_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_reply_placeholder = /** @type {((inputs?: Notes_Reply_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Reply_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reponse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rispondere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отвечать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Responder")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返事")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जवाब")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Responder")
	return /** @type {LocalizedString} */ ("Reply")
});